import { Common } from "../../../common/src";

export class ProjectDetailUtil {
    static isHelmartComplete(status: Common.PROJECT_STATUS_LIST) {
				return (status.helmert_transformation === Common.PROJECT_STATUS_ENUM.COMPLETED
					|| status.verification_helmert === Common.PROJECT_STATUS_ENUM.COMPLETED)
    }

    static isSfMComplete(status: Common.PROJECT_STATUS_LIST) {
				return (status.sfm_processing === Common.PROJECT_STATUS_ENUM.COMPLETED
					|| status.helmert_transformation === Common.PROJECT_STATUS_ENUM.COMPLETED
					|| status.verification_helmert === Common.PROJECT_STATUS_ENUM.COMPLETED
				)
    }

    static reqStringForPointCloud(type: Common.POINT_CLOUD_TYPE) {
		switch (type) {
			case Common.POINT_CLOUD_TYPE.SIMPLE:
				return "LiDAR";
			case Common.POINT_CLOUD_TYPE.SFM:
				return "SfM";
			case Common.POINT_CLOUD_TYPE.HELMERT:
				return "Helmert";
			default:
				return undefined;
		}
	}
}